import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable, of} from 'rxjs';

@HookClass('json')
export class JsonHook extends BaseHook {
    @Hook('8c8b649f-6580-437c-90d2-f1272341131f')
    public jsonApply(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let data = inputArtifact.object.data;

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        // @ts-ignore
        if (data instanceof Array) {
            // @ts-ignore
            outputArtifact.object = JSON[inputArtifact.object.config.name](...data);
        } else {
            // @ts-ignore
            outputArtifact.object = JSON[inputArtifact.object.config.name](data);
        }
        return of(outputArtifact);
    }
}